import React from "react";
import type { SwitchProps } from "@material-ui/core";
import { makeStyles, Switch } from "@material-ui/core";

import type { CoretexTheme } from "../theme";

const useStyles = makeStyles((theme: CoretexTheme) => ({
  root: {
    padding: 0,
    width: "35px",
    height: "16px",
  },
  thumb: {
    width: "15px",
    height: "16px",
    boxShadow: "1px 1px 2px rgba(0, 0, 0, 0.1)",
  },
  track: {
    opacity: 1,
    backgroundColor: theme.palette.mono.gray,
    width: "32px",
    height: "16px",
    borderRadius: "10px",
  },
  switchBase: {
    "&$checked": {
      color: theme.palette.mono.white,
      background: "none",
      transform: "translateX(17px)",
    },
    "&:hover, &$checked:hover": {
      background: "none",
    },
    "&$checked + $track": {
      backgroundColor: theme.palette.colour.primaryBlue,
      opacity: 1,
    },
    padding: 0,
  },
  checked: {},
  focusVisible: {},
}));

const Toggle = (props: SwitchProps): React.ReactElement => {
  const classes = useStyles();

  return (
    <Switch
      disableRipple
      classes={{
        switchBase: classes.switchBase,
        thumb: classes.thumb,
        track: classes.track,
        checked: classes.checked,
        root: classes.root,
      }}
      {...props}
    />
  );
};

export default Toggle;
